import React, { useState } from 'react';
import axios from '../../utils/axios';
import { TextField, Button, Grid, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Footer from '../Partial/footer/footer';
import Navbar from '../Partial/navbar/Navbar';

const NewUser = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const newUser = {email, password, firstName, lastName };
    try {
      const response = await axios.post('/users', newUser);
      if (response.data) {
        // Assuming a successful signup redirects to a login or home page
        navigate('/login'); 
      }
    } catch (error) {
      console.error('Signup failed:', error);
      // Handle errors such as displaying a message to the user
    } finally {
      setLoading(false);
    }
  };
  return (
    <Container maxWidth={false} disableGutters>
      <Navbar />
      <div className="container-fluid">
        <h2>Sign Up</h2>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* First Name */}
            <Grid item xs={12}>
              <TextField
                label="First Name"
                fullWidth
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                placeholder="First Name"
              />
            </Grid>

            {/* Last Name */}
            <Grid item xs={12}>
              <TextField
                label="Last Name"
                fullWidth
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                placeholder="Last Name"
              />
            </Grid>

            {/* Email */}
            <Grid item xs={12}>
              <TextField
                label="Email Address"
                type="email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="email@email.com"
              />
            </Grid>

            {/* Password */}
            <Grid item xs={12}>
              <TextField
                label="Password"
                type="password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={loading}
              >
                {loading ? 'Signing Up...' : 'Sign Up'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
      <Footer />
    </Container>
  );
};

export default NewUser;
